// @flow

import React, { type Node } from 'react';
import { InstructionsText } from '../commons/instructions-text';

export function PaynetInstructions(): Node {
  return (
    <InstructionsText
      title="Datos para pago de tu cupón Paynet"
    >
     Presente el código en tu teléfono celular o imprímalo. También puede dictar los números al cajero
    </InstructionsText>
  );
}
